<!-- Localized -->
<template>
    <UISplitViewModal :config="modalConfig">
        <template v-slot:[detailsSlots.title]>{{ $t('case_creation.due_date') }}</template>
        <template v-slot:[detailsSlots.content]>
            <neo-layout :loading="loading">
                    <div class="w-full flex flex-col items-stretch gap-2">
                        <div class="risk-grid grid grid-cols-7 gap-4 bg-thead rounded-lg px-4 pr-6 py-1 font-medium">
                            <p class="col-span-3"> {{ caseid }} </p>
                            <p class="col-span-1 text-center"> {{ $t('case_creation.sla') }} </p>
                            <p class="col-span-2 text-center"> {{ $t('case_creation.sla_overdue_by') }} </p>
                            <p class="col-span-1 text-center"> </p>
                        </div>
                    
                        <!-- Entities Due Date -->
                        <div  v-for="entity in entities" :key="entity.id">
                            <div class="risk-grid grid grid-cols-7 gap-4 rounded-lg items-center bg-base-250 px-4 pr-6 py-1 font-medium cursor-pointer"
                                :class="selectedEntity?.id === entity.id ? 'bg-base-400': ''"
                                @click="selectEntity(entity)">
                                <p class="col-span-3"> {{ entity.entity_full_name }} </p>
                                <p class="col-span-1 text-center"> {{ entity.sla }} </p>
                                <p class="col-span-2 text-center"> {{ entity.sla_overdue || "-" }} </p>
                                <p class="col-span-1 text-center"> 
                                    <font-awesome-icon
                                        icon="chevron-right"
                                        class="ml-auto text-main text-sm"
                                        :class="selectedEntity?.id === entity.id ? 'transform rotate-180': ''"
                                    />
                                </p>
                            </div>
                        </div>

                        <!-- Checks Due Date -->
                        <div  v-for="check in checks" :key="check.id">
                            <div class="risk-grid grid grid-cols-7 gap-4 rounded-lg items-center bg-base-250 px-4 pr-6 py-1 font-medium cursor-pointer">
                                <p class="col-span-3"> {{ check.name }} </p>
                                <p class="col-span-1 text-center"> {{ check.sla }} </p>
                                <p class="col-span-2 text-center"> {{ check.sla_overdue || "-" }} </p>
                                <p class="col-span-1 text-center"> </p>
                            </div>
                        </div>
                    </div>

                    <div v-if="!selectedEntity?.id" class="flex justify-end mt-4">
                        <Button
                            :text="$t('case_creation.ok')"
                            type="primary"
                            @click="closeModal"
                        />
                    </div>
            </neo-layout>
        </template>

        <template v-slot:subconfig v-if="selectedEntity?.id">
            <div class="h-auto flex-col px-6 py-3 space-y-4 flex items-center justify-center">
                <div class="flex space-x-6">
                    <template v-for="(view, i) in modalConfig">
                        <div v-if="view.show"
                            :key="view.name"
                            class=" max-h-full overflow-y-auto flex flex-col">
                            <div class="bg-primary py-2 px-4 rounded-t-xl text-white-text font-semibold flex items-center justify-between">
                                {{ $t('case_creation.entity_sla') }}
                                <button
                                    v-if="!modalConfig[i + 1]?.show"
                                    class="cursor-pointer h-6 w-6 justify-center items-center flex"
                                    @click="selectEntity(selectedEntity)"
                                >
                                    <font-awesome-icon icon="times" class="text-white-text" />
                                </button>
                            </div>

                            <div class="bg-card-bg rounded-b-xl flex-1 h-full flex overflow-y-auto max-w-full p-4">
                                <neo-layout :loading="loading">
                                    <div class="w-full flex flex-col items-stretch gap-2">
                                        <div class="risk-grid grid grid-cols-6 gap-4 bg-thead rounded-lg px-4 pr-6 py-1 font-medium">
                                            <p class="col-span-3"> {{ caseid }} </p>
                                            <p class="col-span-1 text-center"> {{ $t('case_creation.sla') }} </p>
                                            <p class="col-span-2 text-center"> {{ $t('case_creation.sla_breach') }} </p>
                                        </div>

                                        <!-- Selected Entity --> 
                                        <div class="w-full flex flex-col gap-4 items-center font-medium
                                            border border-solid border-gray-400 rounded-lg">
                                            <div class="risk-grid grid grid-cols-6 gap-4 items-center px-4 pr-6 py-1 font-medium cursor-pointer bg-base-400
                                                w-full">
                                                <p class="col-span-3"> {{ selectedEntity.entity_full_name }} </p>
                                                <p class="col-span-1 text-center"> {{ selectedEntity.sla }} </p>
                                                <p class="col-span-2 text-center"> {{ selectedEntity.sla_overdue || "-" }} </p>
                                            </div>

                                            <!-- Checks Due Date -->
                                            <div class="w-full px-4"  v-for="check in entityChecks" :key="check.id">
                                                <div class="risk-grid grid grid-cols-6 gap-4 rounded-lg items-center bg-base-250 px-4 pr-6 py-1 font-medium cursor-pointer">
                                                    <p class="col-span-3"> {{ check.name }} </p>
                                                    <p class="col-span-1 text-center"> {{ check.sla }} </p>
                                                    <p class="col-span-2 text-center"> {{ check.sla_overdue || "-" }} </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="flex justify-end mt-4">
                                        <Button
                                            :text="$t('case_creation.ok')"
                                            type="primary"
                                            @click="selectEntity(selectedEntity)"
                                        />
                                    </div>
                                </neo-layout>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>
    </UISplitViewModal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Button from "@/components/button";
import NeoLayout from "@shared/components/neo-layout";

export default {
    name: "CaseScoreBreakdown",
    components: {
        Button,
        NeoLayout
    },

    props: {
        caseTypeEntityId: {
            type: String,
            required: true,
        },
        caseEntities: {
            type: Array,
            required: true,
        },
    },

    data() {
        return {
            loading: false,
            riskCategoryBreakdownView: {},
            selectedCategoryId: null,
            selectedEntity: null,
        };
    },

    async mounted() {
    },

    computed: {
        ...mapGetters({
            getEntityDueDateData: "CaseCreationStore/getEntityDueDateData",
            getIsCaseDueDateModalShown: "CaseCreationStore/getIsCaseDueDateModalShown",
        }),

        caseEntity() {
            return this.caseEntities?.find(ce => ce.id === this.caseTypeEntityId) ?? null;
        },

        entities() {
            return (this.getEntityDueDateData?.entities || [])
                .filter(ce => ce.id !== this.caseTypeEntityId)
                .map((ce) => ({
                    ...ce,
                    // sla_overdue_by: new Date() - new Date(ce.entity_due_date),
                })); 
        },

        checks() {
            return (this.getEntityDueDateData?.checks || [])
                .map((ce) => ({
                    ...ce,
                    // sla_overdue_by: new Date() - new Date(ce.check_due_date),
                }));
        },

        entityChecks() {
            return (this.selectedEntity?.checks || [])
                .map((ce) => ({
                    ...ce,
                    // sla_overdue_by: new Date() - new Date(ce.check_due_date),
                }));
        },

        modalConfig() {
            return [{
                name: "details",
                show: this.getIsCaseDueDateModalShown,
                onClose: this.closeModal,
                subconfig: this.selectedEntity?.id,
            }];
        },

        detailsSlots() {
            const [ details ] = this.modalConfig;
            return {
                title: `${details.name}:title`,
                content: `${details.name}:content`,
            };
        },

        caseid() {
            return this.$route.params.caseid;
        }
    },

    watch: {
        getIsCaseDueDateModalShown: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.selectedEntity = null;
                }
            }
        }
    },

    methods: {
        ...mapActions({
            toggleCaseDueDateModal: "CaseCreationStore/toggleCaseDueDateModal",
        }),

        closeModal() {
            this.toggleCaseDueDateModal();
        },

        selectEntity(entity) {
            if (this.selectedEntity?.id === entity.id) {
                this.selectedEntity = null;
                return;
            }
            this.selectedEntity = entity;
        },
    }
}
</script>

<style lang="scss" scoped>
.rotate {
  transform: rotate(180deg);
}

.risk-grid {
//   grid-template-columns: 1fr 100px 100px 25px;

  & > * {
    &:not(:last-child) {
      @apply pr-1;
    }
    &:not(:first-child) {
      @apply pl-1;
    }
  }
}

.breakdown-grid {
  grid-template-columns: 1fr 75px;
}

.risk-grid,
.breakdown-grid {
    p, span {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
